import React from "react";
import classes from "../../styles/Gallery.module.css";
import { convertToShamsi } from "../../../../assets/utils/ConvertToShamsi";

const GalleryElHeaderDate = ({ date }) => {
  return <div className={classes.dateContainer}>{convertToShamsi(date)}</div>;
};

export default GalleryElHeaderDate;
